<!-- 门店库存明细 -->
<template>
    <div class="container">
        <div class="header">
            <img class="width_24 mr12" src="../../assets/information.png">
            <div>
                <div>库存总数每24小时须存更新一次，可以通过更新缓存的方式手动更新。</div>
                <div>1.已经零售出库的产品码，不会计入门店的库存。</div>
                <div>2.未启用的码或空码不会计入门店库存。</div>
            </div>
        </div>
        <div class="header_div">
            <Input class="w200 mr24" type="text" v-model="storePrams.keywords" placeholder="门店名称模糊搜索"></Input>
            <Button class="theme-bc theme-default-color" icon="ios-search" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="show_logo">
                        <div class="flex-c">
                            <img class="width_60 mt12 mb12" :src="row.show_logo">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="type">
                        <div>{{row.type.name}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost @click="goInfo(row)">详情</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 详情 -->
        <Drawer v-model="infoModal" :title="drawerTitle" width="80">
            <div class="drawer_div">
                <Input class="w200 mr24" type="text" v-model="pagesDrawer.qrcode_number" placeholder="输入溯源码编码或扫描溯源码"></Input>
                <Select class="w200 mr24" v-model="pagesDrawer.batch_id" clearable filterable placeholder="选择所属批次">
                    <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                </Select>
                <Select class="w200 mr24" v-model="pagesDrawer.product_id" clearable filterable placeholder="选择所属产品">
                    <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                </Select>
                <Button class="theme-bc theme-default-color" icon="ios-search" @click="goSearchDrawer">确定搜索</Button>
            </div>
            <Table :columns="columnsDrawer" :data="dataDrawer" border>
                <template slot-scope="{ row }" slot="show_product_imgs">
                    <div class="flex-c">
                        <img class="width_60 mt12 mb12" v-if="row.qrcode.product.show_product_imgs" :src="row.qrcode.product.show_product_imgs[0]">
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product">
                    <div>{{row.qrcode.product.product_name}} {{row.qrcode.product.specs}}</div>
                </template>
                <template slot-scope="{ row }" slot="produce_time">
                    <div>
                        <div>生产时间：{{row.qrcode.produce_time}}</div>
                        <div>到期时间：{{row.qrcode.expire_time}}</div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="batch">
                    <div>{{row.qrcode.batch.batch_name}}</div>
                </template>
                <template slot-scope="{ row }" slot="box">
                    <div>
                        <template v-if="row.box">
                            <div v-if="row.box.big_box_number">大箱：{{row.box.big_box_number}}</div>
                            <div v-if="row.box.small_box_number">小箱：{{row.box.small_box_number}}</div>
                        </template>
                        <template v-else><div><Icon type="ios-alert-outline" />未装箱</div></template>
                    </div>
                </template>
            </Table>
            <div class="page">
                <Page :current="pagesDrawer.page" :page-size="pagesDrawer.limit" :total="totalDrawer" show-elevator show-total @on-change="changeDrawer"/>
            </div>
        </Drawer>
    </div>
</template>

<script>
import { 
    warehouse_store_list, 
    warehouse_store_qrcode, 
    batch_select, 
    product_select,
} from '@/api/index';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                keywords: "",
            },
            total: 0,
            columnsTable: [
                { type: 'index', width: 60, align: 'center' },
                { title: "门店图片", slot: "show_logo", align: "center" },
                { title: "门店名称", key: "name", align: "center" },
                { title: "门店类型", slot: "type", align: "center" },
                { title: "库存总数", key: "warehouse_qcode_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataTable: [],
            infoModal: false,
            drawerTitle: "",
            columnsDrawer: [
                { type: 'index', width: 60, align: 'center' },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称及规格", slot: "product", align: "center" },
                { title: "质保期情况", slot: "produce_time", align: "center" },
                { title: "产品溯源码编码", key: "qrcode_number", align: "center" },
                { title: "所属批次", slot: "batch", align: "center" },
                { title: "大(小)箱码", slot: "box", align: "center" },
            ],
            dataDrawer: [],
            pagesDrawer: {
                store_id: "",
                page: 1,
                limit: 10,
                qrcode_number: "",
                batch_id: "",
                product_id: "",
            },
            totalDrawer: 0,
            batchList: [
                { id: 1, name: "批次1" },
                { id: 2, name: "批次2" },
                { id: 3, name: "批次3" },
            ],
            productList: [
                { id: 1, name: "仓库1" },
                { id: 2, name: "仓库2" },
                { id: 3, name: "仓库3" },
            ],
        };
    },
    mounted() {
        this.getList();
        this.getBatchSelect();
        this.getProductSelect();
    },
    methods: {
        getList() {
            warehouse_store_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch(){
            this.storePrams.page = 1;
            this.getList();
        },
        getInfoList() {
            warehouse_store_qrcode(this.pagesDrawer).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeDrawer(index) {
            this.pagesDrawer.page = index;
            this.getInfoList();
        },
        goSearchDrawer(){
            this.pagesDrawer.page = 1;
            this.getInfoList();
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goInfo(row){
            this.drawerTitle = "【" + row.name +"】门店库存明细详情";
            this.pagesDrawer.store_id = row.id;
            this.getInfoList();
            setTimeout(() => {
                this.infoModal = true;
            }, 300);
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    margin-bottom: 24px;
    padding: 24px;
    background: rgba(255,118,29,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.width_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.header_div {
    padding: 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.width_60 {
    width: 60px;
    height: 60px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.drawer_div {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 24px 0;
}
</style>